import React, { forwardRef } from 'react';
import classNames from 'classnames';

import { ContentAreaProps } from './interfaces';

import useStyles from './style';

const ContentArea = forwardRef<HTMLDivElement, ContentAreaProps>(
  ({ className, children, shadowed, ...rest }, ref) => {
    const classes = useStyles();

    return (
      <div
        ref={ref}
        className={classNames('contentArea', classes.contentArea, className, {
          [`${classes.shadowed}`]: shadowed,
        })}
        {...rest}
      >
        {children}
      </div>
    );
  }
);

export default ContentArea;
